import { render, staticRenderFns } from "./ExamineModal.vue?vue&type=template&id=6cbc54b5&scoped=true"
import script from "./ExamineModal.vue?vue&type=script&lang=js"
export * from "./ExamineModal.vue?vue&type=script&lang=js"
import style0 from "./ExamineModal.vue?vue&type=style&index=0&id=6cbc54b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc54b5",
  null
  
)

export default component.exports